module.exports = __webpack_public_path__ + "img/bottom-left-cloud.e930c9eb.svg";